// extracted by mini-css-extract-plugin
export default {"widgetTopBar":"widgetTopBar__DXGlm","innerWrapper":"innerWrapper__fGPPs"};